module.exports = __webpack_public_path__ + "img/Usermanagement.9788cecc.svg";